import { render, staticRenderFns } from "./EmailTemplateEditor.vue?vue&type=template&id=1b72ca06&scoped=true"
import script from "./EmailTemplateEditor.vue?vue&type=script&lang=js"
export * from "./EmailTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72ca06",
  null
  
)

export default component.exports